import { Injectable } from "@angular/core";
import { Ticket } from "src/app/interfaces/support";
import { TicketsService } from "../tickets/tickets.service";
import { firestore } from "firebase/app";
import { AngularFirestore } from "@angular/fire/firestore";
import { Message } from "src/app/interfaces/school";
import { SiselseService } from "../siselse/siselse.service";
@Injectable({
  providedIn: "root",
})
export class SupportService {
  today = new Date();

  public ticketsByCategory = [
    {
      name: "malfunction",
      icon: "no-signal",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "registration",
      icon: "add-friend",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "cards",
      icon: "card",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "operation",
      icon: "settings",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "security",
      icon: "login",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "payment",
      icon: "debit-card",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "sos",
      icon: "alarm-on",
      uTickets: [],
      aTickets: [],
    },
    {
      name: "other",
      icon: "folder",
      uTickets: [],
      aTickets: [],
    },
  ];

  public ticketActive = 0;
  public activeMessages: Message[] = [];

  constructor(
    public ticketServ: TicketsService,
    private afs: AngularFirestore,
    private siselse: SiselseService,
  ) {}

  cleanTickets(tickets: Ticket[]) {
    const expiredTickets: Ticket[] = [];
    this.today.setHours(0, 0, 0, 0);
    const twoMonthsAgo = this.today.setMonth(this.today.getMonth() - 2);
    tickets.forEach((t) => {
      if (
        t.chat[t.chat.length - 1].type === "agent" &&
        t.chat[t.chat.length - 1].ts.toMillis() < twoMonthsAgo &&
        t.status === "open"
      ) {
        expiredTickets.push(t);
      }
    });
    expiredTickets.forEach((t) => {
      t.status = "closed";
      this.ticketServ.closeTicket(t);
      this.ticketServ.addTicketRecord({
        agentName: "system",
        ts: firestore.Timestamp.fromDate(new Date()),
        ticketRef: this.afs.collection("support_tickets").doc(t.id).ref,
        action: "expired",
      });
    });
  }

  loadTickets() {
    /*   setTimeout(() => {
      this.loadRequestCards();
      setInterval(() => this.loadRequestCards(), 30 * 60 * 1000); // 5 minutes
    }, 4000); */
    this.ticketServ.getTickets().subscribe(
      (res) => {
        this.cleanTickets(res);
        this.clearTickets();
        this.ticketServ.ticketsData = res;
        this.ticketServ.ticketsData.forEach((t) => {
          if (t.chat[t.chat.length - 1].type === "user") {
            this.ticketActive++;
            if (t.category === "Operation") {
              this.ticketsByCategory[3].uTickets.push(t);
            } else if (t.category === "Security") {
              this.ticketsByCategory[4].uTickets.push(t);
            } else if (t.category === "Payment") {
              this.ticketsByCategory[5].uTickets.push(t);
            } else if (t.category === "SOS") {
              this.ticketsByCategory[6].uTickets.push(t);
            } else if (t.category === "Other" || t.category === "Device") {
              this.ticketsByCategory[7].uTickets.push(t);
            } else if (t.category === "Malfunction") {
              this.ticketsByCategory[0].uTickets.push(t);
            } else if (t.category === "Registration") {
              this.ticketsByCategory[1].uTickets.push(t);
            }
          } else {
            if (t.category === "Operation") {
              this.ticketsByCategory[3].aTickets.push(t);
            } else if (t.category === "Security") {
              this.ticketsByCategory[4].aTickets.push(t);
            } else if (t.category === "Payment") {
              this.ticketsByCategory[5].aTickets.push(t);
            } else if (t.category === "SOS") {
              this.ticketsByCategory[6].aTickets.push(t);
            } else if (t.category === "Other" || t.category === "Device") {
              this.ticketsByCategory[7].aTickets.push(t);
            } else if (t.category === "Malfunction") {
              this.ticketsByCategory[0].aTickets.push(t);
            } else if (t.category === "Registration") {
              this.ticketsByCategory[1].aTickets.push(t);
            }
          }
        });
        this.ticketsByCategory[1].uTickets.sort(
          (a, b) =>
            a.chat[a.chat.length - 1].ts.toMillis() -
            b.chat[b.chat.length - 1].ts.toMillis(),
        );
      },
      (err) => {
        console.log(err);
      },
    );
  }

  clearTickets() {
    this.ticketActive = 0;
    this.ticketsByCategory.forEach((ticketCategory) => {
      ticketCategory.uTickets = [];
      ticketCategory.aTickets = [];
    });
  }

  async loadMessages(installations: string[]) {
    let messages: Message[] = [];
    try {
      installations.forEach(async (installation) => {
        console.log(installation);
        const msgs = await this.afs
          .collection("messages")
          .doc(installation)
          .collection<Message>("residential", (ref) => {
            return ref.where("status", "==", "open").orderBy("ts", "desc");
          })
          .valueChanges()
          .toPromise();

        console.log("Data from Firestore:", msgs);
      });
    } catch (e) {
      console.error(e);
    }
    console.log(messages);
    this.activeMessages = messages.filter(
      (msg) => msg.chat[msg.chat.length - 1].type === "manager",
    );
  }

  loadRequestCards = () => {
    this.siselse
      .getAllCardsRequest(this.getFormattedDate(0, 7))
      .then((cardsRequest) => {
        // console.log('loadRequestCards', cardsRequest)
        this.ticketsByCategory[2].uTickets = [];
        if (cardsRequest.length > 0)
          cardsRequest.forEach((card) => {
            if (card.domicilio) {
              card.condo_calle = card.domicilio.replace(/\d/g, ""); // Elimina todos los números
              card.condo_numero = card.domicilio.replace(/\D/g, ""); // Elimina todos los caracteres no numéricos
            }
            this.ticketsByCategory[2].uTickets.push(card);
          });
      });
  };

  getFormattedDate(lastMonths: number, days: number): string {
    const now = new Date();
    now.setMonth(now.getMonth() - lastMonths); // Restar un mes
    now.setDate(now.getDate() - days); // Restar los días
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Los meses empiezan desde 0
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
